<div class="container-fluid">
  <div class="row justify-content-between manageaccount mt-3">
    <div class="col-xl-12 col-12 col-sm-12 col-md-12 my-auto">
      <div class="d-flex align-items-center justify-content-between">
        <div class="mb-3">
          <h1 class="fs-4 fw-bold">Manage LR</h1>
          <button
            class="btn btn-sm ms-2 lr-btn"
            mat-raised-button
            routerLink="/superAdmin/lrmanagement"
            routerLinkActive="active-btn"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            LR View
          </button>

          <button
            class="btn btn-sm ms-2 lr-btn"
            mat-raised-button
            routerLink="/superAdmin/lrmanagement/view-tracker"
            routerLinkActive="active-btn"
            [routerLinkActiveOptions]="{ exact: false }"
          >
            Tracker View
          </button>
        </div>
        <div class="d-flex align-items-center gap-2">
          <button
            class="btn btn-sm lr-btn"
            mat-raised-button
            matTooltip="Export to Excel"
            matTooltipPosition="left"
            (click)="exportToExcel()"
          >
            Export
          </button>

          <button
            *ngIf="isAdmin"
            class="btn btn-sm lr-btn"
            mat-raised-button
            routerLink="/superAdmin/lrmanagement/view-tracker-invoice"
            routerLinkActive="active-btn"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            View Invoice
          </button>
          <button
            class="btn btn-dark btn-sm"
            matTooltip="Back"
            matTooltipPosition="left"
            mat-raised-button
            (click)="backTo()"
          >
            <i class="fa-solid fa-arrow-left"></i>
          </button>

          <button
            [matMenuTriggerFor]="menu"
            class="btn btn-dark btn-sm ms-2"
            matTooltipPosition="left"
            mat-raised-button
          >
            <i class="fa-solid fa-plus"></i>
          </button>

          <mat-menu class="mt-2" #menu="matMenu" xPosition="before">
            <p class="whatdoyou">What do you want to add?</p>
            <button
              class="lrtab"
              [routerLink]="['/superAdmin/lrmanagement/add-lr-module/:id']"
              mat-menu-item
            >
              Add LR
            </button>
            <button
              class="lrtab"
              [routerLink]="['/superAdmin/lrmanagement/add-tracker/:id']"
              mat-menu-item
            >
              Add Tracker
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
  </div>
  <div class="contentbox mt-3">
    <div class="row customepadding">
      <div class="filter-flex">
        <div
          class="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 d-flex align-items-center h-100"
        >
          <div class="form-group accountsinp mb-3 flex-fill">
            <label for="search">Search</label>

            <input
              class="search-box form-control"
              #data
              placeholder="Search"
              type="text"
              (keyup)="filterData(data.value)"
            />
          </div>
          <div class="d-flex gap-3 flex-wrap"></div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 col-12">
          <div class="d-flex gap-3 flex-wrap">
            <!-- From Date -->
            <div class="form-group accountsinp mb-3 flex-fill">
              <label for="fromDate">From Date</label>
              <input
                type="date"
                class="form-control shadow-none"
                id="fromDate"
                (change)="onDateChange($event, 'from')"
              />
            </div>

            <!-- To Date -->
            <div class="form-group accountsinp mb-3 flex-fill">
              <label for="toDate">To Date</label>
              <input
                type="date"
                class="form-control shadow-none"
                id="toDate"
                (change)="onDateChange($event, 'to')"
              />
            </div>
          </div>
        </div>

        <!-- Clear Filters Button -->
        <div class="col-sm-1 d-flex align-items-center h-100">
          <button
            class="clearFilterBtn"
            mat-raised-button
            (click)="clearFilters()"
          >
            <img src="/assets/images/svg/ClearFilter.svg" alt="clear" />
          </button>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="table-responsive">
        <table
          mat-table
          [dataSource]="dataSource"
          matSort
          matSortActive="date"
          matSortDirection="desc"
          (matSortChange)="sortData($event)"
          class="row-border hover tablelist"
        >
          <ng-container matColumnDef="Tracker_no">
            <th mat-header-cell *matHeaderCellDef>System Tracker No.</th>
            <td
              mat-cell
              *matCellDef="let receipt; let i = index"
              [routerLink]="[
                '/superAdmin/lrmanagement/detail-tracker',
                receipt._id
              ]"
            >
              {{ receipt?.Tracker_no }}
            </td>
          </ng-container>

          <ng-container matColumnDef="vehicle_Types">
            <th mat-header-cell *matHeaderCellDef class="text-center">
              Vehicle Types
            </th>
            <td mat-cell *matCellDef="let receipt">
              {{ receipt?.vehicleType || "N/A" }}
            </td>
          </ng-container>
          <ng-container matColumnDef="created_by">
            <th mat-header-cell *matHeaderCellDef class="text-center">
              Created By
            </th>
            <td mat-cell *matCellDef="let receipt">
              {{ receipt?.created_by?.full_name || "N/A" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="company">
            <th mat-header-cell *matHeaderCellDef class="text-center">
              Company
            </th>
            <td mat-cell *matCellDef="let receipt">
              {{ receipt?.clientName || "N/A" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="vehicle_id">
            <th mat-header-cell *matHeaderCellDef>Vehicle No.</th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="[
                '/superAdmin/lrmanagement/detail-tracker',
                receipt._id
              ]"
            >
              {{ receipt?.vehicle_id || "N/A" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>Date</th>
            <td mat-cell *matCellDef="let receipt">
              {{ receipt?.date | date : "yyyy-MM-dd" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="from">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>From</th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="[
                '/superAdmin/lrmanagement/detail-tracker',
                receipt._id
              ]"
            >
              {{ receipt?.from || "N/A" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="to">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>To</th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="[
                '/superAdmin/lrmanagement/detail-tracker',
                receipt._id
              ]"
            >
              {{ receipt?.to || "N/A" }}
            </td>
          </ng-container>

          <!-- <ng-container matColumnDef="date">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                          <td mat-cell *matCellDef="let receipt"
                              [routerLink]="['/superAdmin/lrmanagement/view-lr', receipt._id]"> {{receipt.date |
                              date:'yyyy-MM-dd'}} </td>
                      </ng-container> -->

          <!-- <ng-container matColumnDef="stateCode">
                          <th mat-header-cell *matHeaderCellDef class="text-center"> State Code </th>
                          <td mat-cell *matCellDef="let receipt">{{receipt.stateCode}}

                          </td>
                      </ng-container> -->

          <ng-container matColumnDef="fixAdhoc">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Fix/Adhoc</th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="[
                '/superAdmin/lrmanagement/detail-tracker',
                receipt._id
              ]"
            >
              {{ receipt?.fixAdhoc || "N/A" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="startmeterReading">
            <th mat-header-cell *matHeaderCellDef>Start Meter Reading</th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="[
                '/superAdmin/lrmanagement/detail-tracker',
                receipt._id
              ]"
            >
              {{ receipt?.startmeterReading || "N/A" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="endmeterReading">
            <th mat-header-cell *matHeaderCellDef>End Meter Reading</th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="[
                '/superAdmin/lrmanagement/detail-tracker',
                receipt._id
              ]"
            >
              {{ receipt?.endmeterReading || "N/A" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="tripStartDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Trip Start Date
            </th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="[
                '/superAdmin/lrmanagement/detail-tracker',
                receipt._id
              ]"
            >
              {{ receipt?.tripStartDate | date : "yyyy-MM-dd" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="tripEndDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Trip End Date
            </th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="[
                '/superAdmin/lrmanagement/detail-tracker',
                receipt._id
              ]"
            >
              {{ receipt?.tripEndDate | date : "yyyy-MM-dd" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="noofTools">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              No. of Tolls
            </th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="[
                '/superAdmin/lrmanagement/detail-tracker',
                receipt._id
              ]"
            >
              {{ receipt?.noofTools || "N/A" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="up_down_km">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Usage KM</th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="[
                '/superAdmin/lrmanagement/detail-tracker',
                receipt._id
              ]"
            >
              {{ receipt?.up_down_km || "N/A" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="extrahour">
            <th mat-header-cell *matHeaderCellDef>Extra Hours</th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="[
                '/superAdmin/lrmanagement/detail-tracker',
                receipt._id
              ]"
            >
              {{ receipt?.extrahour || "N/A" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="totalExpense">
            <th mat-header-cell *matHeaderCellDef>Total Expense</th>
            <td
              mat-cell
              *matCellDef="let receipt"
              [routerLink]="[
                '/superAdmin/lrmanagement/detail-tracker',
                receipt._id
              ]"
            >
              {{ receipt?.totalExpense || 0 }}
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef class="text-center">
              Action
            </th>
            <td mat-cell *matCellDef="let receipt">
              <div
                class="d-flex justify-content-center align-items-center gap-3"
              >
                <button
                  [routerLink]="[
                    '/superAdmin/lrmanagement/detail-tracker',
                    receipt._id
                  ]"
                  class="btn btn-block p-0 shadow-none"
                >
                  <i matTooltip="View" class="fas fa-eye"></i>
                </button>
                <button
                  *ngIf="isAdmin || isSuperSupervisor"

                  [routerLink]="[
                    '/superAdmin/lrmanagement/edit-tracker',
                    receipt._id
                  ]"
                  class="btn btn-block p-0 shadow-none"
                >
                  <i matTooltip="Edit" class="fa-solid fa-pen-to-square"></i>
                </button>
                <button
                  *ngIf="isAdmin"
                  class="btn btn-block p-0 shadow-none"
                  matTooltip="Delete"
                  (click)="deleteTracker(receipt)"
                >
                  <i class="fa-solid fa-trash"></i>
                </button>

                <!-- <button [routerLink]="['/superAdmin/lrmanagement/view-lr', receipt._id]"
                                class="btn btn-block p-0 shadow-none"><i matTooltip="Print" class="fas fa-print"></i></button> -->
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
      <mat-paginator
        #paginator
        [length]="totalRecords"
        [pageSize]="pageSize"
        [pageSizeOptions]="[5, 10, 25, 100]"
        (page)="onPageChange($event)"
      >
      </mat-paginator>
    </div>
  </div>
</div>
<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
